export default __webpack_public_path__ + "static/media/material-products-liquid.0b8c8167.svg";